let nextWalletId = 4006;
const businessOfflineAvailable = process.env.VUE_APP_MOCK_BUSINESS_OFFLINE_AVAILABLE !== 'false';
const withdrawals = [];
const recharges = [];
const offlineSnapshots = new Map([[4005, { lifecycle: 2, settleProgress: null }]]);

const rates = {
  walletTypeSettings: {
    bkash: { minOnlineBalance: 1000, repayRate: 0.5, repayFixed: 0, disburseRate: 0.4, disburseFixed: 1, repayOrdersPerMinuteLimit: 2, repayWindowMinutes: 1 },
    nagad: { minOnlineBalance: 1500, repayRate: 0.6, repayFixed: 1, disburseRate: 0.3, disburseFixed: 2, repayOrdersPerMinuteLimit: 3, repayWindowMinutes: 5 }
  },
  maxWalletsPerCustomer: 5,
  repayRate: 0.5,
  repayFixed: 0,
  disburseRate: 0.4,
  disburseFixed: 1,
  minOnlineBalance: 1000,
  supportTelegramUrl: '',
  withdrawFee: 10
};

const wallets = [
  {
    crowdWalletId: 4005,
    walletNo: '01722222222',
    walletType: 'bKash',
    lifecycle: 3,
    baselineBalance: 1000,
    remainingPrincipal: 1000,
    totalCommission: 0,
    withdrawable: 1000,
    settleProgress: { lifecycle: 3, offlineRequestTime: '2026-09-04 12:00:00', settleOrderNo: null }
  },
  {
    crowdWalletId: 4004,
    walletNo: '01711111111',
    walletType: 'bKash',
    lifecycle: '0',
    baselineBalance: 0,
    remainingPrincipal: 0,
    totalCommission: 0,
    illegalAmount: 0,
    withdrawnAmount: 0,
    withdrawable: 0
  },
  {
    crowdWalletId: 4001,
    walletNo: '01700000000',
    walletType: 'bKash',
    lifecycle: 2,
    receivePaused: false,
    currentBalance: 2860.75,
    baselineBalance: 2400,
    remainingPrincipal: 2400,
    totalCommission: 1280.5,
    illegalAmount: 0,
    withdrawnAmount: 500,
    withdrawable: 3180.5
  },
  {
    crowdWalletId: 4002,
    walletNo: '01855000319',
    walletType: 'Nagad',
    lifecycle: 1,
    baselineBalance: 620,
    remainingPrincipal: 620,
    totalCommission: 0,
    illegalAmount: 0,
    withdrawnAmount: 0,
    withdrawable: 620
  },
  {
    crowdWalletId: 4003,
    walletNo: '01999123456',
    walletType: 'bKash',
    lifecycle: 9,
    baselineBalance: 1800,
    remainingPrincipal: 1800,
    totalCommission: 340,
    illegalAmount: 260,
    withdrawnAmount: 0,
    withdrawable: 1880
  }
];

wallets.forEach(wallet => {
  if (wallet.receivePaused === undefined) wallet.receivePaused = false;
  if (wallet.businessOffline === undefined) wallet.businessOffline = false;
  wallet.businessOfflineAvailable = businessOfflineAvailable;
  if (wallet.currentBalance === undefined) wallet.currentBalance = null;
  recomputeWallet(wallet);
});

let ledger = [
  row(1, 4001, 'RP202609040010', 500, 0.5, 0, 2.5, '2026-09-04 11:42:00'),
  row(2, 4001, 'PO202609040011', 750, 0.4, 1, 4, '2026-09-04 10:18:00'),
  row(7, 4001, 'WD202609030006', 500, 0, 0, -500, '2026-09-03 19:00:00'),
  row(3, 4003, 'IL202609020002', 260, 0, 0, -260, '2026-09-02 16:35:00'),
  row(1, 4001, 'RP202609020001', 1000, 0.5, 0, 5, '2026-09-02 09:30:00')
];

function row(bizType, crowdWalletId, refNo, orderAmount, rateSnapshot, fixedSnapshot, commissionAmount, createTime) {
  return { bizType, crowdWalletId, refNo, orderAmount, rateSnapshot, fixedSnapshot, commissionAmount, createTime };
}

function later(data, delay = 180) {
  return new Promise((resolve) => {
    window.setTimeout(() => resolve(JSON.parse(JSON.stringify(data))), delay);
  });
}

export function recomputeWallet(wallet) {
  wallet.accountingWithdrawable = Math.max(0, Number(wallet.baselineBalance || 0)
    + Number(wallet.totalCommission || 0)
    - Number(wallet.illegalAmount || 0)
    - Number(wallet.withdrawnAmount || 0)
    - Number(wallet.reservedWithdrawalAmount || 0));
  // Mock server contract only. Live views must use the returned withdrawable unchanged.
  wallet.retainedWalletBalance = 0;
  wallet.withdrawable = Math.round(wallet.accountingWithdrawable * 100) / 100;
  if (wallet.platformOnlyWithdrawal) {
    const known = wallet.currentBalance !== null && wallet.currentBalance !== undefined
      && wallet.currentBalance !== '' && Number.isFinite(Number(wallet.currentBalance)) && Number(wallet.currentBalance) >= 0;
    wallet.retainedWalletBalance = known ? Number(wallet.currentBalance) : null;
    wallet.withdrawable = known ? Math.max(0, Math.round((wallet.accountingWithdrawable - wallet.retainedWalletBalance) * 100) / 100) : null;
  }
}

function filterLedger(params = {}) {
  return ledger.filter((item) => {
    if (params.crowdWalletId && item.crowdWalletId !== Number(params.crowdWalletId)) return false;
    const day = String(item.createTime || '').slice(0, 10);
    if (params.from && day < params.from) return false;
    if (params.to && day > params.to) return false;
    return true;
  });
}

export default {
  getRates() {
    return later(rates);
  },
  sendEmailCode() {
    return later(null);
  },
  sendPasswordResetCode() {
    return later(null);
  },
  resetPassword() {
    return later(null);
  },
  register() {
    return later(Date.now());
  },
  login() {
    return later({ token: 'mock-crowd-token' });
  },
  getSummary() {
    const todayCommission = ledger
      .filter((item) => item.createTime.startsWith('2026-09-04') && [1, 2].includes(item.bizType))
      .reduce((sum, item) => sum + Number(item.commissionAmount || 0), 0);
    return later({
      customerNo: '12000',
      todayCommission,
      totalCommission: wallets.reduce((sum, item) => sum + Number(item.totalCommission || 0), 0),
      withdrawable: wallets.reduce((sum, item) => sum + Number(item.withdrawable || 0), 0),
      wallets
    });
  },
  getWallets() {
    return later(wallets);
  },
  bindWallet(payload) {
    const wallet = {
      crowdWalletId: nextWalletId++,
      walletNo: payload.walletNo,
      walletType: payload.walletType,
      lifecycle: 0,
      receivePaused: false,
      businessOffline: false,
      businessOfflineAvailable,
      currentBalance: null,
      baselineBalance: 0,
      remainingPrincipal: 0,
      totalCommission: 0,
      illegalAmount: 0,
      withdrawnAmount: 0,
      withdrawable: 0
    };
    recomputeWallet(wallet);
    wallets.unshift(wallet);
    return later(wallet.crowdWalletId);
  },
	  editPendingWallet(payload) {
	    const wallet = wallets.find((item) => String(item.crowdWalletId) === String(payload.crowdWalletId));
	    if (!wallet || Number(wallet.lifecycle) !== 0 || !/^01\d{9}$/.test(String(payload.walletNo || '').trim())
	      || !String(payload.pin || '').trim()) {
	      return Promise.reject(new Error('Invalid pending wallet edit'));
	    }
	    wallet.walletNo = String(payload.walletNo).trim();
	    return later(true);
	  },
	  submitOtp(payload) {
	    const wallet = wallets.find((item) => String(item.crowdWalletId) === String(payload.crowdWalletId));
	    if (!wallet) {
	      return Promise.reject(new Error('Wallet not found'));
	    }
	    wallet.lifecycle = 1;
	    return later(true);
	  },
  updateWalletPin(payload) {
    const wallet = wallets.find((item) => String(item.crowdWalletId) === String(payload.crowdWalletId));
    if (!wallet || !payload.pin || ![2, 6].includes(Number(wallet.lifecycle))) {
      return Promise.reject(new Error('Invalid PIN update request'));
    }
    return later(true);
  },
  sendWalletReloginOtp(payload) {
    const wallet = wallets.find((item) => String(item.crowdWalletId) === String(payload.crowdWalletId));
    if (!wallet || ![2, 6].includes(Number(wallet.lifecycle))) {
      return Promise.reject(new Error('Invalid OTP login request'));
    }
    return later(true);
  },
  verifyWalletReloginOtp(payload) {
    const wallet = wallets.find((item) => String(item.crowdWalletId) === String(payload.crowdWalletId));
    if (!wallet || !payload.rawSms || ![2, 6].includes(Number(wallet.lifecycle))) {
      return Promise.reject(new Error('Invalid OTP login request'));
    }
    return later(true);
  },
	  checkWallet(payload) {
	    const wallet = wallets.find((item) => item.crowdWalletId === payload.crowdWalletId);
    if (wallet) {
      const minimum = rates.walletTypeSettings[String(wallet.walletType).toLowerCase()].minOnlineBalance;
      const addedPrincipal = Math.max(0, minimum - wallet.baselineBalance);
      wallet.baselineBalance += addedPrincipal;
      wallet.remainingPrincipal += addedPrincipal;
      wallet.currentBalance = wallet.baselineBalance;
      wallet.lifecycle = 2;
      recomputeWallet(wallet);
    }
    return later(wallet);
  },
  cancelBind(payload) {
    const index = wallets.findIndex((item) => item.crowdWalletId === payload.crowdWalletId);
    if (index >= 0) {
      wallets.splice(index, 1);
    }
    return later(true);
  },
  withdraw(request) {
    const existing = withdrawals.find(item => item.requestKey === request.requestKey);
    if (existing) return later(existing);
    const wallet = wallets.find((item) => item.crowdWalletId === request.crowdWalletId);
    const fee = Number.isFinite(Number(rates.withdrawFee)) && Number(rates.withdrawFee) >= 0 ? Number(rates.withdrawFee) : 10;
    const receiveAmount = Math.round((Number(request.amount) - fee) * 100) / 100;
    if (!request.requestKey || !wallet || wallet.withdrawable === null || Number(wallet.lifecycle) !== 2
      || !Number.isFinite(Number(request.amount)) || receiveAmount < 100 || Number(request.amount) > wallet.withdrawable) {
      return Promise.reject(new Error('Invalid withdrawal request'));
    }
    wallet.reservedWithdrawalAmount = Number(wallet.reservedWithdrawalAmount || 0) + Number(request.amount);
    wallet.lifecycle = 6;
    recomputeWallet(wallet);
    const requestNo = `WD${Date.now()}`;
    const accepted = {
      requestKey: request.requestKey,
      requestNo,
      crowdWalletId: request.crowdWalletId,
      targetWalletType: request.targetWalletType,
      targetWalletNo: request.targetWalletNo,
      amount: request.amount,
      feeAmount: fee,
      receiveAmount,
      remainingWithdrawable: wallet ? wallet.withdrawable : 0,
      paidAmount: 0,
      pendingAmount: receiveAmount,
      createTime: new Date().toISOString(),
      remark: '',
      status: 10
    };
    withdrawals.unshift(accepted);
    return later(accepted);
  },
  withdrawalPage(params) {
    const page = Number(params && params.page) || 1;
    const pageSize = Number(params && params.pageSize) || 20;
    const records = params && params.crowdWalletId
      ? withdrawals.filter(item => String(item.crowdWalletId) === String(params.crowdWalletId))
      : withdrawals;
    return later({ records: records.slice((page - 1) * pageSize, page * pageSize), total: records.length });
  },
  recharge(request) {
    const wallet = wallets.find((item) => String(item.crowdWalletId) === String(request.crowdWalletId));
    if (!wallet || ![2, 6, 9].includes(Number(wallet.lifecycle)) || !Number.isFinite(Number(request.amount)) || Number(request.amount) <= 0 || !request.transactionId) {
      return Promise.reject(new Error('Invalid recharge request'));
    }
    const record = {
      id: Date.now(),
      requestNo: `RC${Date.now()}`,
      crowdWalletId: request.crowdWalletId,
      walletNo: wallet.walletNo,
      walletType: wallet.walletType,
      amount: Number(request.amount),
      transactionId: request.transactionId,
      status: 40,
      statusText: 'WAITING_CLEARING',
      remark: 'Waiting for a matching wallet transaction.',
      createdAt: new Date().toISOString()
    };
    recharges.unshift(record);
    return later(record);
  },
  rechargePage(params) {
    const records = recharges.filter(item => !params.crowdWalletId || String(item.crowdWalletId) === String(params.crowdWalletId));
    const page = Number(params.page || 1);
    const pageSize = Number(params.pageSize || 20);
    return later({ records: records.slice((page - 1) * pageSize, page * pageSize), total: records.length });
  },
  offline(payload) {
    const wallet = wallets.find(item => String(item.crowdWalletId) === String(payload.crowdWalletId));
    if (!wallet || !businessOfflineAvailable || Number(wallet.lifecycle) !== 2) return later(false);
    wallet.businessOffline = true;
    return later(true);
  },
  resume(payload) {
    const wallet = wallets.find(item => String(item.crowdWalletId) === String(payload.crowdWalletId));
    if (!wallet || !businessOfflineAvailable || Number(wallet.lifecycle) !== 2) return later(false);
    wallet.businessOffline = false;
    return later(true);
  },
  verifyWithdrawalBalance(payload) {
    const wallet = wallets.find(item => String(item.crowdWalletId) === String(payload.crowdWalletId));
    if (!wallet || Number(wallet.lifecycle) !== 2) return later({ canApply: false, unavailableReason: 'WALLET_UNAVAILABLE' });
    recomputeWallet(wallet);
    const available = wallet.withdrawable;
    return later({ canApply: available !== null && available >= 110, availableAmount: available,
      retainedWalletBalance: wallet.retainedWalletBalance, platformOnlyWithdrawal: Boolean(wallet.platformOnlyWithdrawal),
      unavailableReason: available === null ? 'BALANCE_UNAVAILABLE' : available < 110 ? 'BELOW_MINIMUM' : null });
  },
  pauseReceive(payload) {
    const wallet = wallets.find(item => String(item.crowdWalletId) === String(payload.crowdWalletId));
    if (!wallet || Number(wallet.lifecycle) !== 2) return later(false);
    wallet.receivePaused = true;
    return later(true);
  },
  resumeReceive(payload) {
    const wallet = wallets.find(item => String(item.crowdWalletId) === String(payload.crowdWalletId));
    if (!wallet || Number(wallet.lifecycle) !== 2) return later(false);
    wallet.receivePaused = false;
    return later(true);
  },
  cancelOffline(payload) {
    const wallet = wallets.find(item => item.crowdWalletId === payload.crowdWalletId);
    const previous = offlineSnapshots.get(payload.crowdWalletId);
    if (!wallet || wallet.lifecycle !== 3 || !previous) return later(false);
    Object.assign(wallet, previous);
    offlineSnapshots.delete(payload.crowdWalletId);
    return later(true);
  },
  settleProgress(crowdWalletId) {
    const wallet = wallets.find((item) => item.crowdWalletId === Number(crowdWalletId));
    return later((wallet && wallet.settleProgress) || {
      lifecycle: wallet ? wallet.lifecycle : 5,
      offlineRequestTime: null,
      lockStartTime: null,
      onlineTime: null,
      offlineTime: null,
      settleOrderNo: null
    });
  },
  ledgerPage(params = {}) {
    const page = Number(params.page || 1);
    const size = Number(params.size || 10);
    const filtered = filterLedger(params);
    return later({
      records: filtered.slice((page - 1) * size, page * size),
      total: filtered.length,
      page,
      size
    });
  },
  ledgerDaily(params = {}) {
    const id = params.crowdWalletId ? Number(params.crowdWalletId) : null;
    const base = [
      { day: '2026-08-30', commissionAmount: 18.5 },
      { day: '2026-08-31', commissionAmount: 28 },
      { day: '2026-09-01', commissionAmount: 21 },
      { day: '2026-09-02', commissionAmount: id === 4003 ? 0 : 35 },
      { day: '2026-09-03', commissionAmount: 44 },
      { day: '2026-09-04', commissionAmount: 6.5 }
    ];
    return later(base.filter(row => (!params.from || row.day >= params.from) && (!params.to || row.day <= params.to)));
  },
  ledgerSummary(params = {}) {
    const rows = filterLedger(params);
    const summary = rows.reduce((acc, row) => {
      const amount = Number(row.commissionAmount || 0);
      acc.totalAmount += amount;
      acc.recordCount += 1;
      if (Number(row.bizType) === 1) acc.repayAmount += amount;
      else if (Number(row.bizType) === 2) acc.disburseAmount += amount;
      else acc.adjustmentAmount += amount;
      return acc;
    }, { totalAmount: 0, repayAmount: 0, disburseAmount: 0, adjustmentAmount: 0, recordCount: 0 });
    return later(summary);
  }
};
